export default {
  COLORS: {
    PRIMARY: "#eb6811",
    SECONDARY: "#039E4B",

    GREEN: "#469B54",
    RED: "#FF0000",

    YELLOW_700: "#855F00",
    YELLOW_200: "#FFCE52",
    YELLOW_100: "#FFEBB9",

    GRAY_800: "#212121",
    GRAY_700: "#424242",
    GRAY_600: "#616161",
    GRAY_500: "#757575",
    GRAY_400: "#9E9E9E",
    GRAY_300: "#BDBDBD",
    GRAY_200: "#e0e0e0",
    GRAY_100: "#e9e2db",
  },
  FONT_WEIGHT: {
    REGULAR: 400,
    BOLD: 800,
  },
  FONT_SIZE: {
    SMALL: "0.98rem",
    PARAGRAPH: "1.6rem",
    H5: "2.588rem",
    H4: "4.188rem",
    H3: "6.777rem",
    H2: "10.965rem",
    H1: "17.7424rem",
  },
}
